<template lang="pug">
v-app-bar#wbc-header(app, :elevation="0")
  div(v-if="!isMobile().phone")
    v-img(:src="require('@/assets/site_logo.png')", height="40px", contain, position="left center")
  v-spacer
  div(v-if="!isMobile().phone")
    v-menu(v-model="menu", :close-on-content-click="false", :nudge-width="200", offset-x)
      template(v-slot:activator="{ on, attrs }")
        v-btn.mr-4(text, v-bind="attrs", v-on="on")
          v-icon.mr-2 mdi-help
          span {{ $t('header.contact') }}
      v-card
        v-img(:src="require('@/assets/link_contact.gif')")
    v-btn.mr-4(depressed, color="primary", href=process.env.VUE_APP_WBC_BASE_URL + '/samlsso/home?id=wbc')
      v-icon.mr-2 mdi-login-variant
      span {{ $t('header.loginToConsole') }}
  cookie-law(theme="base", buttonText="OK", position="top", v-on:accept="isAccept")
    div(slot="message") {{ $t('header.CookieLowMessage') }}
</template>

<script>
// cookie使用同意
import CookieLaw from "vue-cookie-law"
// sp判定
import isMobile from "ismobilejs"
export default {
  components: { CookieLaw },
  methods: {
    isAccept: function () {
      if (isMobile().phone) {
        // 同意でspならログインへ移動
        window.location.href = process.env.VUE_APP_WBC_BASE_URL + "/samlsso/home?id=wbc"
      }
    },
  },
  data() {
    return { isMobile, menu: "" }
  },
}
</script>

<style lang="sass" scoped>
$bg-blur-radius: 12px
#wbc-header
  background-color: rgba(255, 255, 255, .72)
  backdrop-filter: blur($bg-blur-radius) brightness(1.2) saturate(1.2)
  -webkit-backdrop-filter: blur($bg-blur-radius) brightness(1.2) saturate(1.2)
</style>